<div
  class="tabs"
  *ngIf="user$ | async">
  <nav
    mat-tab-nav-bar
    class="themed-tab-nav">
    <a
      mat-tab-link
      *ngFor="let tab of tabs$ | async"
      (click)="switchTab(tab.value)"
      [active]="(tabParam$ | async) == tab.value"
      [attr.data-cy]="'state-' + tab.value + '-toggle-button'">
      {{ tab.label | i18n }}
    </a>
  </nav>
</div>
<form
  #tariffsForm="ngForm"
  class="tariffs-list">
  <mat-card
    class="tariffs-index-transfers-list-item mat-elevation-z2"
    *ngFor="let customerTariff of customerTariffs$ | async">
    <mat-card-title>
      <h2>{{ customerTariff.targetCustomer.displayName }}</h2>
    </mat-card-title>
    <mat-card-content>
      <div
        class="row"
        *ngFor="let tariff of customerTariff.tariffs">
        <div class="col col-md-8">
          <app-certificate-select
            [selectedMappedCertificates]="tariff.certificates"
            [excludedMappedCertificates]="customerTariff.excludedCertificates"
            (selectionChanged)="certificatesSelected(tariff, $event)">
          </app-certificate-select>
        </div>
        <div class="col col-md-4">
          <div class="tariff-hourlywage-row">
            <mat-form-field>
              <mat-label>{{
                ("hourlyWage" | i18n) || "hourly wage in CHF"
              }}</mat-label>
              <input
                matInput
                required
                [(ngModel)]="tariff.hourlyWage"
                [name]="'hourlyWage-' + tariff.id" />
            </mat-form-field>
            <button
              class="remove-tariff-button"
              mat-button
              type="button"
              (click)="removeTariff(customerTariff, tariff.id)">
              <mat-icon
                class="remove-tariff-button-icon"
                svgIcon="delete-trash-remove"></mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button
            class="outline-pill-button icon-left"
            type="button"
            (click)="addNewTariff(customerTariff)">
            <mat-icon
              class="custom-text-icon-button-icon"
              svgIcon="add-circle-plus"></mat-icon>
            {{ ("addTariff" | i18n) || "add tariff" | titlecase }}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>
<div
  class="floating-actions-bar"
  *ngIf="tariffsForm.form.dirty">
  <button
    (click)="cancelChanges()"
    class="secondary-pill-button icon-left big-fab"
    type="button"
    data-cy="save-tariff-button">
    <mat-icon svgIcon="close"></mat-icon>
    {{ ("cancel" | i18n) || "cancel" | titlecase }}
  </button>
  <button
    (click)="saveTariffs()"
    class="primary-pill-button icon-left big-fab"
    [disabled]="tariffsForm.invalid || !(noEmptyCertificates$ | async)"
    type="submit"
    data-cy="save-tariff-button">
    <mat-icon svgIcon="save"></mat-icon>
    {{ ("save" | i18n) || "save" | titlecase }}
  </button>
</div>
